import { stripHtml } from "./strip-html.js";
import html_content_module_default from "./html-content.module.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/html-content/HtmlContent.tsx
/**
* Note: NEVER use this component with user-generated data! This is intended for
* the sole purpose of abstracting away the code needed to style dynamic HTML
* content coming from Prescryptive PRO or some future Prescryptive-managed CMS.
* It should _NOT_ be considered generally safe to use with any arbitrary HTML.
*/
const HtmlContent = ({ content, "data-testid": testId }) => {
	if (!stripHtml(content).length) return null;
	return /* @__PURE__ */ jsx("div", {
		className: html_content_module_default.htmlContent,
		"data-testid": testId,
		dangerouslySetInnerHTML: { __html: content }
	});
};

//#endregion
export { HtmlContent };